module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "keywords": _vm.keyword,
      "toptype": _vm.toptype,
      "types": "3",
      "isSearch": _vm.path
    },
    on: {
      "tosearch": _vm.tosearch
    }
  }), _vm._v(" "), _c('div', {}, [(_vm.config) ? _c('div', {}, [_c('el-image', {
    staticClass: "topimg",
    attrs: {
      "src": _vm._f("addurl")(_vm.config.pxfu_pic),
      "fit": "fill"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marginauto conwidth topall"
  }, [_c('div', {
    staticClass: "flex justify-start align-center"
  }, [_c('div', {
    staticStyle: {
      "color": "#959595",
      "font-size": "16px",
      "margin-right": "15px",
      "line-height": "37px",
      "width": "100px"
    }
  }, [_vm._v("培训类型：")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start align-center flex-wrap"
  }, _vm._l((_vm.sortlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "topone pointer",
      class: item.checked ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.tabchange(item.id, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), (_vm.list.length) ? _c('div', {
    staticClass: "response bggray"
  }, [_c('div', {
    staticClass: "conwidth marginauto",
    staticStyle: {
      "min-height": "400px",
      "padding-top": "45px"
    }
  }, [_c('div', {
    staticClass: " flex justify-between align-center flex-wrap"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "animated slideInRight",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "bg-white flex justify-center align-center pointer hvr-float",
      staticStyle: {
        "padding": "20px 20px 20px 15px",
        "width": "615px",
        "border-radius": "5px",
        "margin-bottom": "30px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "220px",
        "height": "220px",
        "display": "block"
      },
      attrs: {
        "src": _vm._f("addurl")(item.image),
        "fit": "cover"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-sub",
      staticStyle: {
        "padding": "0 20px",
        "height": "220px"
      }
    }, [_c('div', {
      staticClass: "text-cut2",
      staticStyle: {
        "color": "#1c1c1c",
        "font-size": "20px",
        "line-height": "32px",
        "height": "64px",
        "margin-top": "10px",
        "margin-bottom": "25px"
      }
    }, [_vm._v("\n                                    " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#909090",
        "font-size": "17px",
        "margin-bottom": "10px"
      }
    }, [_vm._v("活动时间：" + _vm._s(item.active_time))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#909090",
        "font-size": "17px"
      }
    }, [_vm._v("活动地点：" + _vm._s(item.address))]), _vm._v(" "), _c('div', {
      staticClass: "dbtn"
    }, [_vm._v("了解详情→")])])], 1)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-center res",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pagerCount,
      "hide-on-single-page": true,
      "page-size": _vm.pagesize,
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.list.length && !_vm.load) ? _c('div', {}, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9191f32c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/train.vue
// module id = 412
// module chunks = 1